/* ============================================================
   DSA SHOPIFY THEME — JavaScript
   Mobile nav, filter tabs, form handling
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ---------- MOBILE NAV TOGGLE ---------- */
  var toggle = document.getElementById('mobile-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  var iconOpen = document.getElementById('menu-icon-open');
  var iconClose = document.getElementById('menu-icon-close');

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      if (iconOpen) iconOpen.style.display = isOpen ? 'none' : 'block';
      if (iconClose) iconClose.style.display = isOpen ? 'block' : 'none';
    });

    var mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        if (iconOpen) iconOpen.style.display = 'block';
        if (iconClose) iconClose.style.display = 'none';
      });
    });
  }

  /* ---------- RESOURCE FILTER TABS ---------- */
  var filterTabs = document.querySelectorAll('.filter-tab');
  var resourceItems = document.querySelectorAll('.resource-list-item');

  if (filterTabs.length > 0 && resourceItems.length > 0) {
    filterTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        filterTabs.forEach(function(t) { t.classList.remove('filter-tab--active'); });
        tab.classList.add('filter-tab--active');

        var category = tab.getAttribute('data-filter');

        resourceItems.forEach(function(item) {
          if (category === 'all' || item.getAttribute('data-category') === category) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  }

  /* ---------- CONSULTING FORM VALIDATION ---------- */
  var consultingForm = document.getElementById('consulting-form');
  if (consultingForm) {
    consultingForm.addEventListener('submit', function(e) {
      var name = document.getElementById('consulting-name');
      var email = document.getElementById('consulting-email');
      var message = document.getElementById('consulting-message');
      var errors = [];

      if (name && !name.value.trim()) errors.push('Full Name is required');
      if (email && !email.value.trim()) errors.push('Email is required');
      if (email && email.value && !email.value.includes('@')) errors.push('Please enter a valid email');
      if (message && !message.value.trim()) errors.push('Message is required');

      if (errors.length > 0) {
        e.preventDefault();
        alert(errors.join('\n'));
        return false;
      }
    });
  }

  /* ---------- LEAD MAGNET FORM HANDLING ---------- */
  var leadForms = document.querySelectorAll('[id^="lead-magnet-form-"]');
  leadForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var emailInput = form.querySelector('input[type="email"]');
      if (emailInput && !emailInput.value.includes('@')) {
        e.preventDefault();
        alert('Please enter a valid email address.');
        return false;
      }
    });
  });

  /* ---------- ACTIVE NAV LINK HIGHLIGHT ---------- */
  var currentPath = window.location.pathname;
  var headerLinks = document.querySelectorAll('.header__link');
  headerLinks.forEach(function(link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('header__link--active');
    }
  });

  /* ---------- SMOOTH SCROLL FOR ANCHOR LINKS ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId && targetId.length > 1) {
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

});
